/* tslint:disable */
/* eslint-disable */
/**
 * Incendium AI API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 *
 * @export
 * @enum {string}
 */
export var ApiAIBillingType;
(function (ApiAIBillingType) {
    ApiAIBillingType["AI_BILLING_TYPE_UNSPECIFIED"] = "AIBillingTypeUnspecified";
    ApiAIBillingType["AI_BILLING_TYPE_CHART_BUILDER"] = "AIBillingTypeChartBuilder";
    ApiAIBillingType["AI_BILLING_TYPE_CHART_ANALYSIS"] = "AIBillingTypeChartAnalysis";
    ApiAIBillingType["AI_BILLING_TYPE_DEEP_DIVE"] = "AIBillingTypeDeepDive";
    ApiAIBillingType["AI_BILLING_TYPE_LANDING_PAGE_BUILD"] = "AIBillingTypeLandingPageBuild";
    ApiAIBillingType["AI_BILLING_TYPE_COMPONENT_BLOCK"] = "AIBillingTypeComponentBlock";
    ApiAIBillingType["AI_BILLING_TYPE_CHART_BASIC_ANALYSIS"] = "AIBillingTypeChartBasicAnalysis";
    ApiAIBillingType["AI_BILLING_TYPE_IMAGE_GENERATION"] = "AIBillingTypeImageGeneration";
    ApiAIBillingType["AI_BILLING_TYPE_IMAGE_EDITING"] = "AIBillingTypeImageEditing";
    ApiAIBillingType["AI_BILLING_TYPE_IMAGE_GENERATION_CONTEXT"] = "AIBillingTypeImageGenerationContext";
    ApiAIBillingType["AI_BILLING_TYPE_IMAGE_EDITING_CONTEXT"] = "AIBillingTypeImageEditingContext";
    ApiAIBillingType["AI_BILLING_TYPE_LANDING_PAGE_ADVANCED"] = "AIBillingTypeLandingPageAdvanced";
    ApiAIBillingType["AI_BILLING_TYPE_LANDING_COMPONENT"] = "AIBillingTypeLandingComponent";
    ApiAIBillingType["AI_BILLING_TYPE_LANDING_COMPONENT_ADVANCED"] = "AIBillingTypeLandingComponentAdvanced";
    ApiAIBillingType["AI_BILLING_TYPE_LANDING_BLOCK"] = "AIBillingTypeLandingBlock";
    ApiAIBillingType["AI_BILLING_TYPE_LANDING_BLOCK_ADVANCED"] = "AIBillingTypeLandingBlockAdvanced";
})(ApiAIBillingType || (ApiAIBillingType = {}));
export function ApiAIBillingTypeFromJSON(json) {
    return ApiAIBillingTypeFromJSONTyped(json, false);
}
export function ApiAIBillingTypeFromJSONTyped(json, ignoreDiscriminator) {
    return json;
}
export function ApiAIBillingTypeToJSON(value) {
    return value;
}
